export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "color": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Couleur (hex)"])}
      },
      "en": {
        "color": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Color (hex)"])}
      }
    }
  })
}
